import { PrefixedId } from './prefixed-id';
export const NavItemId = PrefixedId('nid::');
export const nid = NavItemId.create;